import React from "react";
import {
  Box,
  Container,
  Stack,
  Heading,
  Text,
  Button,
  Flex,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function PricingPage() {
  const navigate = useNavigate();

  return (
    <Box>
      <Header />
      <Box as="section" py="20" bg="gray.50">
        <Container maxW="container.lg">
          <Stack spacing="6" textAlign="center" mb="12">
            <Heading>Pricing</Heading>
            <Text fontSize="lg">
              Vartaverse is free for everyone! Enjoy all features with no hidden
              fees.
            </Text>
          </Stack>
          <Flex justifyContent="center" alignItems="center">
            <Box
              bg="white"
              p="8"
              borderRadius="md"
              boxShadow="md"
              textAlign="center"
              maxW="sm"
              w="100%"
            >
              <Heading size="lg">Free</Heading>
              <Text fontSize="2xl" mt="4" fontWeight="bold">
                $0
              </Text>
              <Text mt="2">
                Access all features with unlimited connectivity.
              </Text>
              <Button
                mt="6"
                colorScheme="teal"
                onClick={() => navigate("/signup")}
              >
                Get Started
              </Button>
            </Box>
          </Flex>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
}

export default PricingPage;
